export default function(actors, operations) {
    let status = '';
    if (!operations || !Object.keys(operations).length) {
        return status;
    }

    if (actors.departments.length > 0) {
        return 'pending';
    }

    for (let user of actors.users) {
        if (!(user.id in operations)) {
            status = 'pending';
            continue;
        }
        for (let operation of operations[user.id]) {
            switch (operation?.action) {
                case 'decline':
                    return 'decline'
                case 'rework':
                    return 'rework'
                case 'approve':
                case 'sign':
                    if (status !== 'pending'){
                        status = operation.action;
                    }
                    break;
                default:
                    status = 'pending';
                    break;
            }
        }
    }
    return status;
}
